import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { pipelineOptions, subPipelineOptions } from "src/components/common/functions";

const yesNoAllOptions = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
    { value: "all", label: "All" },
];

const yesNoOptions = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
];

export const fields: FilterFieldConfig[] = [
    { key: "projectName", label: "Project", type: "text", default: "" },
    {
        key: "category",
        label: "Category",
        type: "select",
        default: "",
        options: Object.keys(pipelineOptions).map(value => ({ value, label: value })),
    },
    {
        key: "subCategory",
        label: "Sub Category",
        type: "select",
        default: "",
        options: Array.from(new Set(Object.values(subPipelineOptions).flat())).map(value => ({ value, label: value })),
    },
    { key: "location", label: "Location", type: "text", default: "" },
    { key: "startTime", label: "Start Time", type: "range", default: "", inputType: "date" },
    { key: "endTime", label: "End Time", type: "range", default: "", inputType: "date" },
    { key: "allDay", label: "All Day", type: "select", default: "", options: yesNoOptions },
    { key: "supervisorId", label: "Supervisor", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "siteContactId", label: "Site Contact", type: "asyncSelect", default: "",
        fileName: "common/searchContact.php",
        placeholder: "Search Contact",
        isMulti: false, 
    },

    { key: "cadRequired", label: "CAD Required", type: "select", default: "", options: yesNoOptions },
    { key: "reportRequired", label: "Report Required", type: "select", default: "", options: yesNoOptions },
    { key: "waiveJSA", label: "Waive JSA", type: "select", default: "", options: yesNoOptions },

    { key: "leadId", label: "Lead", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false, 
    },
    
    { key: "description", label: "Description", type: "text", default: "" },

    {
        key: "creatorId",
        label: "Created By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    {
        key: "updaterId",
        label: "Updated By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no", options: yesNoAllOptions },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function WorkFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
